import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';

const startOtpOuter = (controller: AbortController, setOtpCode: Dispatch<SetStateAction<string | null>>) => {
    if (!('OTPCredential' in window)) {
        return;
    }

    navigator.credentials
        .get({
            otp: { transport: ['sms'] },
            signal: controller.signal
        } as any)
        .then((otp: any) => {
            if (otp && otp.code) {
                setOtpCode(otp.code);
            }
        });
};

export function useOTP() {
    const [otpCode, setOtpCode] = useState<string | null>(null);
    const controllerRef = useRef<AbortController | null>(null);

    const cancelOTP = useCallback(() => {
        if (controllerRef.current) {
            controllerRef.current.abort();
            controllerRef.current = null;
        }
    }, []);

    const startOTP = () => {
        controllerRef.current = new AbortController();
        startOtpOuter(controllerRef.current, setOtpCode);
    };

    useEffect(() => {
        return () => {
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
        };
    }, []);

    return { otpCode, startOTP, cancelOTP };
}
